import { useState, useEffect } from "react";
import { Box, Typography, Button, Card, CardContent, TextField, Alert, CircularProgress, Snackbar } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";

const token = () => localStorage.getItem("biyz_token");
const authHead = () => ({ Authorization: `Bearer ${token()}`, "Content-Type": "application/json" });

export default function InvitePage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState("");

  useEffect(() => {
    fetch("/api/platform/gamification/referral", { headers: authHead() })
      .then(r => r.json()).then(d => { if (d?.ok) setData(d); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  const copy = (txt) => {
    try { navigator.clipboard.writeText(txt); setToast("Kopyalandı ✓"); }
    catch { setToast("Kopyalanamadı"); }
  };

  if (loading) return <Box sx={{ display: "flex", justifyContent: "center", mt: 10 }}><CircularProgress /></Box>;

  const link = data?.link || "";
  const code = data?.code || "";
  const rewardDays = data?.rewardDays || 7;
  const waText = encodeURIComponent(`biYAPAYZEKA ile dil öğreniyorum, sana da öneririm! Bu linkle kayıt ol, ikimiz de ${rewardDays} gün ücretsiz kazanalım: ${link}`);

  return (
    <Box sx={{ maxWidth: 640, mx: "auto", px: { xs: 1.5, sm: 3 }, py: 3, width: "100%", boxSizing: "border-box" }}>
      <Typography variant="h5" fontWeight={800} sx={{ color: "#1a2238", mb: 0.5 }}>Arkadaşını Davet Et 🎁</Typography>
      <Typography color="text.secondary" sx={{ mb: 3 }}>
        Davet ettiğin her arkadaş kayıt olduğunda <b>ikiniz de {rewardDays} gün ücretsiz</b> ek süre kazanırsınız.
      </Typography>

      <Card sx={{ borderRadius: 4, mb: 2.5, background: "linear-gradient(135deg,rgba(79,124,255,0.08),rgba(139,108,255,0.08))", border: "1px solid rgba(79,124,255,0.25)" }}>
        <CardContent>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
            <CardGiftcardIcon sx={{ color: "#8B6CFF" }} />
            <Typography fontWeight={700} sx={{ color: "#1a2238" }}>Davet Kodun</Typography>
          </Box>
          <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
            <TextField fullWidth value={code} InputProps={{ readOnly: true, sx: { fontWeight: 800, letterSpacing: 2, fontSize: 18 } }} />
            <Button variant="outlined" onClick={() => copy(code)} startIcon={<ContentCopyIcon />}>Kopyala</Button>
          </Box>
          <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
            <TextField fullWidth value={link} InputProps={{ readOnly: true, sx: { fontSize: 13 } }} />
            <Button variant="outlined" onClick={() => copy(link)} startIcon={<ContentCopyIcon />}>Link</Button>
          </Box>
          <Button fullWidth variant="contained" startIcon={<WhatsAppIcon />}
            href={`https://wa.me/?text=${waText}`} target="_blank" rel="noopener"
            sx={{ height: 48, fontWeight: 700, background: "#25D366", "&:hover": { background: "#1da851" } }}>
            WhatsApp ile Paylaş
          </Button>
        </CardContent>
      </Card>

      <Alert severity="info" icon={false} sx={{ borderRadius: 3 }}>
        🏆 Şimdiye kadar davet ettiğin arkadaş sayısı: <b>{data?.count || 0}</b>
      </Alert>

      <Snackbar open={!!toast} autoHideDuration={2000} onClose={() => setToast("")} message={toast}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }} />
    </Box>
  );
}

